'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function isAuthError(error) {
  return error.graphQLErrors.some(err => {
    var _err$extensions;
    return ((_err$extensions = err.extensions) === null || _err$extensions === void 0 ? void 0 : _err$extensions.code) === 'UNAUTHENTICATED';
  });
}

exports.isAuthError = isAuthError;
